import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  ErrorHandler,
  inject,
} from '@angular/core';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogConfig,
} from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconRegistry } from '@angular/material/icon';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  RouteReuseStrategy,
  withRouterConfig,
} from '@angular/router';
import { ErrorHandlerService } from '@errors/error-handler';
import { MatPaginatorIntlJp } from '@intl/paginator';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { routes } from './app.routes';
import { apiInterceptor } from './services/api-interceptor';
import { CustomRouteReuseStrategy } from './services/custom-route-reuse-strategy';
import { AngularMarkdownEditorModule } from 'angular-markdown-editor';
import { MAT_SELECT_CONFIG } from '@angular/material/select';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({ canceledNavigationResolution: 'computed' }),
    ),
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    provideHttpClient(withInterceptors([apiInterceptor])),
    provideHttpClient(),
    provideAnimations(),
    Location,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    provideAnimationsAsync(),
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlJp },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        ...new MatDialogConfig(),
        autoFocus: false,
        disableClose: true,
      },
    },
    {
      // mat-hintの領域が使用していない場合、非表示となるように設定
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: 'dynamic' },
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: () => {
        const iconRegistry = inject(MatIconRegistry);
        return () => {
          iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
        };
      },
    },
    provideCharts(withDefaultRegisterables()),
    importProvidersFrom(
      AngularMarkdownEditorModule.forRoot({ iconlibrary: 'fa' }),
    ),
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { hideSingleSelectionIndicator: true },
    },
  ],
};
